var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.v-primary",modifiers:{"hover":true,"v-primary":true}}],staticStyle:{"margin-right":"5px"},attrs:{"pill":"","variant":"info","disabled":_vm.disableButton,"title":"Descargar a Excel"},on:{"click":_vm.exportFile}},[_vm._v(" Descargar a Excel")])
}
var staticRenderFns = []

export { render, staticRenderFns }